module.exports = __webpack_public_path__ + "img/dummy_logo.0403a3fc.png";